// 9fbef606107a605d69c0edbcd8029e5d

export const TOTAL_IMAGES = 15;
const badgeTranformation = 'g_west,w_0.22,fl_relative';

export const IMG_DATA_CLP = {
  imgConfig: ['t_mod_G_img_product_m', 't_mod_G_img_product_t', 't_mod_G_img_product_d'],
  badgeConfig: [badgeTranformation, badgeTranformation, badgeTranformation],
};

export const IMG_DATA_CLP_SIMILAR = {
  imgConfig: ['t_plp_img_m', 't_plp_img_t', 't_plp_img_d'],
  badgeConfig: [badgeTranformation, badgeTranformation, badgeTranformation],
};

export const ARROW_VISIBLE_BP = {
  1200: 4,
  1440: 5,
  1920: 6,
  default: 4,
};

export const ARROW_VISIBLE_STORE_SPECIALS = {
  1200: 2,
  1440: 3,
  1920: 4,
  default: 2,
};

export const SLIDES_TO_SCROLL_BP = {
  1200: 4,
  1440: 4,
  1920: 3,
  default: 3,
};
export const SLIDES_TO_SCROLL_BP_SIMILAR_STYLES = {
  1200: 4,
  1440: 5,
  1920: 3,
  default: 3,
};

export const calculateBreakPointByWidth = ([innerWidth]) => {
  if (innerWidth < 1440) return 1200;
  if (innerWidth < 1920) return 1440;
  if (innerWidth >= 1920) return 1920;
  return 'default';
};
